/* unplugin-vue-components disabled */
import PulseInput from './pulse-input.vue'

export default {
  components: {
    PulseInput
  },
  mixins: [ModelValue(String)],
  props: {
    loading: {type: Boolean, required: false},
    placeholder: {type: String, default: 'Search'},
    regexp: {type: String, default: undefined}
  },
  emits: ['update:valid'],
  data() {
    return {
      valid: true
    }
  },
  methods: {
    focus(){
      this.$refs.input.focus()
    }
  }
}

